// extracted by mini-css-extract-plugin
export default {"menu-item":"tGR862k2dtll02ss_Ceo","add-btn":"tFaF9OLrcEVxpFSaCCcr"};